import viacep from "@/api/viacep";
import Swal from "sweetalert2";

export function formatCurrency(value) {
  if (value == null) return "";

  const strValue = typeof value === "number" ? value.toFixed(2) : String(value);
  let cleaned = strValue.replace(/[^\d,.-]/g, "");

  if (cleaned.includes(",")) {
    cleaned = cleaned.replace(/\./g, "").replace(",", ".");
  }

  const currencyValue = parseFloat(cleaned);
  if (isNaN(currencyValue)) return "";

  return (
    "R$ " +
    currencyValue
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
  );
}

export function parseCurrency(value) {
  if (!value) return "";
  const number = value.replace("R$ ", "").replace(/\./g, "").replace(",", ".");
  return number;
}

export function parseCurrencyToNumber(value) {
  if (!value) return 0;
  const cleanedValue = value.replace("R$ ", "").replace(/\./g, "").replace(",", ".");
  const number = parseFloat(cleanedValue);
  return isNaN(number) ? 0 : number;
}

export function handleInput(value) {
  if (!value) return "0,00";

  // Remove tudo que não for número
  const digitsOnly = value.replace(/\D/g, "");

  // Converte para centavos e formata com vírgula
  const numericValue = (parseFloat(digitsOnly) / 100).toFixed(2);

  // Retorna no formato brasileiro esperado pelo formatCurrency
  return numericValue.replace(".", ","); // ← Isso é o essencial!
}

export function formatDecimal(value) {
  const cleanedValue = value.replace(/[^\d,]/g, "").replace(",", ".");
  const decimalValue = parseFloat(cleanedValue);

  if (isNaN(decimalValue)) {
    return "";
  }
  return decimalValue
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
}

export function parseDecimal(value) {
  if (!value) return "";
  const number = value.replace(/\./g, "").replace(",", ".");
  const parsedValue = parseFloat(number);
  return isNaN(parsedValue) ? "" : parsedValue.toFixed(2);
}

export async function validarCampoCep(
  obj,
  { tipoEndereco = null, somenteValidar = false } = {},
) {
  const cepField = obterNomeCampo("Cep", tipoEndereco);
  if (!somenteValidar) {
    const logradouroField = obterNomeCampo("Logradouro", tipoEndereco);
    const bairroField = obterNomeCampo("Bairro", tipoEndereco);
    const cidadeField = obterNomeCampo("Cidade", tipoEndereco);
    const ufField = obterNomeCampo("Uf", tipoEndereco);
    const paisField = obterNomeCampo("Pais", tipoEndereco);

    if (!obj[cepField]) return false;
    obj[cepField] = obj[cepField].replace(/\D/g, "");
    if (obj[cepField].length !== 8) {
      mostarErroCep();
      limparCamposEndereco(obj, tipoEndereco);
      return false;
    }

    try {
      const { data } = await viacep.get(`/ws/${obj[cepField]}/json/`);
      if (data.erro) {
        mostarErroCep();
        limparCamposEndereco(obj, tipoEndereco);
        return false;
      } else {
        obj[logradouroField] = data.logradouro;
        obj[bairroField] = data.bairro;
        obj[cidadeField] = data.localidade;
        obj[ufField] = data.uf;
        obj[paisField] = "BRA";
        return true;
      }
    } catch (error) {
      mostarErroCep();
      limparCamposEndereco(obj, tipoEndereco);
      return false;
    }
  } else {
    try {
      const { data } = await viacep.get(`/ws/${obj[cepField]}/json/`);
      if (data.erro) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      return false;
    }
  }
}

function obterNomeCampo(base, tipoEndereco) {
  if (!tipoEndereco) return base;
  const tipoEnderecoLower = tipoEndereco.toLowerCase();
  if (tipoEnderecoLower === "outro") {
    return `${base}${capitalize(tipoEndereco)}`;
  } else if (tipoEnderecoLower === "enderecocomercial") {
    switch (base) {
      case "Logradouro":
        return "EnderecoComercial";
      case "Uf":
        return `${capitalize(tipoEndereco)}Estado`;
      default:
        return `${capitalize(tipoEndereco)}${base}`;
    }
  } else {
    return base;
  }
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function limparCamposEndereco(obj, tipoEndereco = null) {
  const logradouroField = obterNomeCampo("Logradouro", tipoEndereco);
  const bairroField = obterNomeCampo("Bairro", tipoEndereco);
  const cidadeField = obterNomeCampo("Cidade", tipoEndereco);
  const ufField = obterNomeCampo("Uf", tipoEndereco);
  const paisField = obterNomeCampo("Pais", tipoEndereco);

  obj[logradouroField] = "";
  obj[bairroField] = "";
  obj[cidadeField] = "";
  obj[ufField] = "";
  obj[paisField] = "";
}

function mostarErroCep() {
  Swal.fire({
    icon: "warning",
    title: "Atenção!",
    text: `O CEP informado não foi encontrado. Verifique e tente novamente ou preencha os campos manualmente. Para CEP's fora do Brasil, o preenchimento manual é necessário.`,
  });
}

export const ufs = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];
